import { Component, OnDestroy, OnInit } from '@angular/core';
import { QbeIcons } from 'qbe-components';
import { ProcessService, ProcessType } from '../../services/process.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import * as fromProcess from '../../store/process/process.reducer';
import { RadioButton } from '../../component/radio-buttons/radio-buttons.component';
import { Observable, Subject, first, takeUntil, tap } from 'rxjs';
import { PersistStorageKeys, PersistStorageService } from '../../services/persist-storage.service';
import { FormsService } from '../../services/forms.service';
import { TrackingService } from '../../tracking/tracking.service';
import { Router } from '@angular/router';
import { GtmService } from '../../services/gtm.service';

interface HorizontalButton extends RadioButton {
  value: ProcessType;
}

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss'],
})
export class Step1Component implements OnInit, OnDestroy {
  horizontalButtons: HorizontalButton[] = [
    {
      label: 'home.tripAbroad',
      qbeIcon: QbeIcons.WorldGlobe,
      value: ProcessType.TRIPABROAD,
    },
    {
      label: 'home.travelInPL',
      qbeIcon: QbeIcons.Poland,
      value: ProcessType.TRAVELINPL,
    },
    {
      label: 'home.resignation',
      // qbeIcon: QbeIcons.ProductCalendar,
      ndbxIcon: 'product-calendar',
      value: ProcessType.RESIGNATION,
    },
  ];
  destroy$ = new Subject<void>();
  processKind$: Observable<ProcessType | null> = this.store.select(fromProcess.selectProcessKind);
  nextStepUrl$ = this.store.select(fromProcess.selectProcessNextStepUrl);

  constructor(
    private store: Store<AppState>,
    private persistStorage: PersistStorageService,
    private processService: ProcessService,
    private formsService: FormsService,
    private trackingService: TrackingService,
    private router: Router,
    private gtmService: GtmService,
  ) {}

  ngOnInit() {
    this.formsService.resetApp();
    this.persistStorage.setBoolean(PersistStorageKeys.IsRemote, false, 'session');

    this.store.dispatch(fromProcess.actions.setStep({ step: 0 }));
    this.processService.onPageInit();

    this.trackingService.businessEventStart();
    this.gtmService.step1Event();
    this.restoreProcesKindAfterReset();
  }

  handleChange(data: RadioButton) {
    this.store.dispatch(fromProcess.actions.setKind({ kind: data.value as ProcessType }));
    this.trackingService.insuranceSubject(data.value as ProcessType);
    this.persistStorage.setString(PersistStorageKeys.ProcesKind, data.value.toString(), 'session');

    this.nextStepUrl$
      .pipe(
        takeUntil(this.destroy$),
        first(),
        tap((nextStepUrl) => {
          this.trackingService.nextPage();
          void this.router.navigate(nextStepUrl);
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private restoreProcesKindAfterReset() {
    const procesKind = this.persistStorage.getString(PersistStorageKeys.ProcesKind, 'session');
    if (procesKind) {
      this.store.dispatch(fromProcess.actions.setKind({ kind: procesKind as ProcessType }));
    }
  }
}
